import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Mui from '@material-ui/core';
import * as MuiIcons from '@material-ui/icons';

const ModalJustificativaCancelamento = ({ title, showModal, onClose, callback }) => {
  const [justificativa, setJustificativa] = useState(null);

  const handleSubmit = () => {
    if (justificativa?.length < 15) {
      toast.warning('O motivo deve ter no mínimo 15 caracteres.');
      return false;
    }

    onClose();
    if (callback) {
      callback(justificativa);
    }
  };

  return (
    <Mui.Dialog
      open={showModal}
      onKeyDown={key => {
        if (key.code === 'Escape') {
          onClose();
        }
      }}
      PaperComponent={Mui.Paper}
      maxWidth={'md'}
    >
      <Mui.DialogContent style={{ width: 560, padding: 32, paddingBottom: 8 }}>
        <Mui.Box textAlign="center" style={{ marginBottom: '16px' }}>
          <Mui.Typography variant="h2" style={{ marginBottom: '32px' }}>
            {title ? title : 'Cancelamento documento '}
          </Mui.Typography>
          <Mui.TextField
            label="Justificativa"
            variant="outlined"
            minRows={3}
            fullWidth
            value={justificativa}
            onChange={e => setJustificativa(e.target.value)}
            error={!justificativa || justificativa?.length > 300}
          />
          <span>{justificativa?.length ?? 0}/300</span>
        </Mui.Box>
      </Mui.DialogContent>
      <Mui.DialogActions style={{ padding: 32, paddingTop: 8, alignItems: 'stretch' }}>
        <Mui.Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={!justificativa || justificativa?.length > 300}
        >
          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <MuiIcons.CheckCircle style={{position: 'relative', bottom: '2px'}}/>
            <span style={{ verticalAlign: 'middle' }}>Confirmar e Fechar</span>
          </span>
        </Mui.Button>
        <Mui.Button size="large" onClick={onClose}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <MuiIcons.Cancel style={{position: 'relative', bottom: '1px'}}/>
            <span style={{ verticalAlign: 'middle' }}>Cancelar (ESC)</span>
          </span>
        </Mui.Button>
      </Mui.DialogActions>
    </Mui.Dialog>
  );
};

export default ModalJustificativaCancelamento;
